import React from 'react';
import ReactDOM from 'react-dom';
import Home from './home';

// Importing the Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(<Home />, document.getElementById('root'));
